import emptyListOne from "../assets/svg/error-vectors/Reading list-cuate.svg"
import chartOne from "../assets/svg/error-vectors/chart-vector.svg"
import writerError from "../assets/svg/error-vectors/writing_vector.svg"
import sorryOneError from "../assets/svg/error-vectors/Feeling sorry-cuate.svg"

export const RaikoErrorSectionVectors = {
    EMPTY_LIST_ONE: emptyListOne,
    SORRY_ONE: sorryOneError,
    WRITER: writerError,
    chartOne: chartOne,
}

